<template>
  <div class="time_sheet">
    <el-table :data="tableData" border v-loading="loading" :cell-class-name="addClass" :header-cell-class-name="addClass" width="100%">
      <!-- 汇总表 -->
       <template v-if="currTab=='allTimeSheet'">
        <el-table-column v-for="(item, index) in allTimesheetTitle" :key="index" :prop="item.prop" :label="item.label"
          min-width="100px">
         
        </el-table-column>
    </template>
    <!-- 详表 -->
    <template v-if="currTab=='timeSheet'">
       <el-table-column prop="label" label=" " width="150"  fixed v-if="!!tableData&&!!tableData.length"> </el-table-column>
      <el-table-column v-for="(i, index) in listLabel" :label="i" align="center" header-align="center" :key="index" width="100px">
       
          <template v-slot="scope" >
            <template v-if="!!scope.row.tsDeliverablesResponses[i]&&!!scope.row.tsDeliverablesResponses[i].length">
             <el-popover placement="top" trigger="hover" > 
            <div @click="goAdress(info)" v-for="(info,k) in scope.row.tsDeliverablesResponses[i]" style="cursor:pointer;color:#2D8CF0">
             {{k+1}}：{{info.deliverablesName}}
            </div>
            <!-- //悬浮窗口内容为每行的customerUser 这个字段 -->
            <div slot="reference" class="name-wrapper">
                <div>{{ scope.row[i] }}</div>
            </div>
          </el-popover>
            </template>
          <template v-else>
            {{ scope.row[i] }}
          </template>
          </template>
        </el-table-column>
    </template>
    <template v-if="currTab=='deliverablesList'">
        <el-table-column v-for="(item, index) in deliverablesListTitle" :key="index" :prop="item.prop" :label="item.label"
         show-overflow-tooltip :min-width="(item.prop=='yunzhou_address'||item.prop=='job_description')?'130px':item.prop=='create_date'?'150px':item.prop=='name_of_deliverables'?'300px':'100px'">
         
          <template slot-scope="scope">
            <template v-if="item.prop=='yunzhou_address'">
               <a @click="goYunzhou(scope.row)">查看</a>
            </template>
            <template v-else>
              {{scope.row[item.prop]}}
            </template>
          </template>
        </el-table-column>
    </template>
     
    </el-table>
    <el-pagination background layout="prev, pager, next" :total="allTotal" class="page_content" v-if="this.currTab=='deliverablesList'"
      @current-change="currentChange" @prev-click="prevClick" @next-click="nextClick">
    </el-pagination>
    <toast :is-toast="isToast" :msg="toastMsg"></toast>
  </div>
</template>
<script>
  import {
    TimeSheet,PhpTimesheet
  } from '../../../API/api.js'
  import Toast from "@/components/popup/Toast";
  import {
  checkFile, downloadFile
} from "@/util/util.js"
  export default {
    components: {
      Toast
    },
    props: {

      projectInfo: {
        type: Object
      },
      currTab:{
        type:String
      }
    },
    data() {
      return {
        searchParams: {
          limit: 10,
          page: 1,
          Id: this.projectInfo.projectId
        },
        loading: true,
        isToast: false,
        toastMsg: "",
        listLabel: [
          ],
        allTimesheetTitle:[
          {
          label: '人员',
          prop: 'userName'
          },
          {
          label: '预算工时',
          prop: 'estimateCount'
          },
          {
          label: '待消耗',
          prop: 'consumedWorkingHours'
          },
          {
          label: '已消耗',
          prop: 'sumWorkingHours'
          },
          {
          label: '超时数',
          prop: 'numberOfTimeouts'
          },
        ],
        deliverablesListTitle: [
          {
          label: '工作日期',
          prop: 'working_date'
        },
        {
          label: '负责人',
          prop: 'userName'
        },
       
        {
          label: '交付物名称',
          prop: 'name_of_deliverables'
        },      
        {
          label: '交付物版本',
          prop: 'deliverable_version_name'
        },
        {
          label: '难度系数',
          prop: 'degree_of_difficulty_name'
        },        
        {
          label: '工作时长',
          prop: 'working_hours'
        },        
        {
          label: '交付物上传地址',
          prop: 'yunzhou_address'
        },        
        {
          label: '登记日期',
          prop: 'create_date'
        },
        {
          label: '工作描述',
          prop: 'job_description'
        },
        {
          label: '交付物类型',
          prop: 'type_name'
        },
         {
          label: '交付物',
          prop: 'deliverables_name'
        }, 

       
         ],
        tableData: [],
        allTotal: 0,
        requestUrl:'',
      }
    },
    methods: {
      goAdress(item){
        console.log(item,'item------1')
        let info={
          yunzhou_address:item.fileUrl,
          remark2:item.fileName
        }
        this.goYunzhou(info)
      },
       //查看链接
    goYunzhou(item) {
      let url = item.yunzhou_address, name = item.remark2;
      if (url.indexOf("http://cloud.normcore.com/") > -1) {
        window.open(url, "_blank")
      } else {
        let checkFileUrl = checkFile(url);
        console.log(checkFileUrl,'checkFileUrl-----')
        if (checkFileUrl == 'video') {
          window.open(url, "_blank");

        } else {
          downloadFile(url, name)

        }
      }
    },
   
      addClass({row,column,rowIndex,columnIndex}){ 
       if(columnIndex==4&&this.currTab=='allTimeSheet'){  //此判断为前两列
          return 'addBorder'
        }
    },
      currentChange(curpage) {
        console.log('123', curpage)
        this.searchParams.page = curpage;
        this.getByIdList();
      },
      prevClick(curpage) {
        this.searchParams.page = curpage;
        this.getByIdList();

      },
      nextClick(curpage) {
        this.searchParams.page = curpage;
        this.getByIdList();
      },
      getTableData() {
        this.listLabel = [{
          label: '',
          prop: 'workingDate'
        }, ];
        this.$http
          .post(TimeSheet.getWorkHours, this.qs.stringify({
            Id: this.projectInfo.projectId
          }))
          .then((res) => {
            this.loading = false;
            let _data = res.data
            if (_data.retCode === 200) {
             
            } else {
              this.isToast = true;
              this.toastMsg = `${_data.retMsg}`;
            }
            setTimeout(() => {
              this.isToast = false;
              this.toastMsg = "";
            }, 1500);
          })
          .catch((res) => {

          });
      },
      getByIdList() {
        this.tableData = [];
        this.$http
          .post(this.requestUrl, this.qs.stringify(this.searchParams))
          .then((res) => {
            let _data = res.data
            this.loading = false;
            if (_data.retCode === 0||_data.retCode === 200) {
              const _dataArr = []
              this.allTotal = Number(_data.retData.count)||0;
             if(this.currTab=='timeSheet'){
               for (let i of _data.retData.data) {
                let userId = i.userId
                // console.log(i,'i------')
                const {workingDate,sumWorkingHours,userName,tsDeliverablesResponses}=i
                _dataArr.push({
                  workingDate,
                  [`${userId}`]: sumWorkingHours,
                  sumWorkingHours,
                  userId,
                  userName,
                  tsDeliverablesResponses
                })
                
              }
              console.log(_dataArr,'_dataArr-----')
              let tempArr = [];
              let newArr = [];
              let listLabel=[];
              let allId=[]
              for (let i = 0; i < _dataArr.length; i++) {
                let userId = _dataArr[i].userId;
                if(allId.indexOf(userId) === -1){
                  allId.push(userId);
                newArr.push({
                  label:_dataArr[i].userName,
                [`${_dataArr[i].workingDate}`]:_dataArr[i].sumWorkingHours,
                userId:userId,
                tsDeliverablesResponses:{
                  [`${_dataArr[i].workingDate}`]: _dataArr[i].tsDeliverablesResponses,
                }
                })
                }else{
                      for (let j = 0; j < newArr.length; j++) {
                        console.log()
                    if (newArr[j].userId === _dataArr[i].userId) {
                      let obj = {
                       [`${_dataArr[i].workingDate}`]:_dataArr[i].sumWorkingHours,
                       tsDeliverablesResponses:{
                           ...newArr[j].tsDeliverablesResponses,
                         [`${_dataArr[i].workingDate}`]:_dataArr[i].tsDeliverablesResponses,
                       }
                     
                       
                      }
                      newArr[j] = {
                        ...newArr[j],
                        ...obj,

                      }
                    }
                  
                  }
                }
                if (tempArr.indexOf(_dataArr[i].workingDate) === -1) {
                  tempArr.push(_dataArr[i].workingDate);
                }
              }
              this.tableData = newArr;
              console.log(this.tableData,'this.tableData')
              this.listLabel=tempArr;
            for(let i=0;i<this.tableData.length;i++){
              let sumWorking=0;
              for(let j of tempArr){
              //  (0.1*10+0.2*10)/10
              // label:  i.userName +'（总：' + i.sumWorkingHours + '）',
              // sumWorking+=parseFloat(this.tableData[i][j])
              sumWorking=(this.tableData[i][j]*10+sumWorking*10)/10
              }
              this.tableData[i].label=this.tableData[i].label+'（总：' + sumWorking + '）'
            }
             }else if(
              //交付物清单
              this.currTab=='deliverablesList'){
                this.tableData = _data.retData.data;
            }else if(this.currTab=='allTimeSheet'){
               this.tableData = _data.retData;
            }

            } else {
               this.isToast = true;
              this.toastMsg = `${_data.retMsg}`;
            }
             setTimeout(() => {
              this.isToast = false;
              this.toastMsg = "";
            }, 1500);
          })
          .catch((res) => {

          });
      }
    },
    mounted() {
     //人工时统计
      if(this.currTab=='timeSheet'){
      //  this.getTableData();
        this.searchParams.limit=1000
        this.requestUrl=TimeSheet.getByIdList;
        console.log( this.searchParams.limit,' this.searchParams.limit')
        //
      }else if(this.currTab=='deliverablesList'){
      this.requestUrl=PhpTimesheet.getdeliverables;
      delete this.searchParams.limit;
      delete this.searchParams.Id;
      this.searchParams.pageSize=10;
      this.searchParams.projectId=this.projectInfo.projectId;
      }else if(this.currTab=='allTimeSheet'){
       this.requestUrl=TimeSheet.tsSumWorkHoursById;
       this.searchParams={
        Id:this.projectInfo.projectId
       }
      }
      
       this.getByIdList();
      console.log(this.requestUrl,'currTrequestUrlab----')
    }
  }

</script>
<style lang="less" scoped>
  .page_content {
    margin-top: 20px;
    display: flex;
    justify-content: end;
  }
/deep/.addBorder{
  color: red !important;
}
</style>
